import { getCLOnCallOverlapMessage } from '@lp/features/AssignmentTables/ClinicalLeadsTable/utils';
import { CLAssignmentCandidate, EmployeeRole } from '@/api/apis/resources';
import { ResourceWarning, WarningType } from '../types';

export const createClinicalLeadWarningHandler = (toggleWarning: (warning: ResourceWarning) => void) => {
  return (candidate: CLAssignmentCandidate) => {
    const {
      phoneSupportStart,
      phoneSupportEnd,
      overlapOnCallShiftStart,
      overlapOnCallShiftEnd,
      employeeId,
      employeeFullName,
    } = candidate;

    const onCallOverlapMessage = getCLOnCallOverlapMessage(
      phoneSupportStart,
      phoneSupportEnd,
      overlapOnCallShiftStart,
      overlapOnCallShiftEnd,
    );

    if (onCallOverlapMessage) {
      const warning: ResourceWarning = {
        id: `${employeeId}:${EmployeeRole.ClinicalLead}:reservation`,
        type: WarningType.ClinicalLead,
        employeeId,
        role: EmployeeRole.ClinicalLead,
        message: `${employeeFullName || 'Clinical Lead'}: ${onCallOverlapMessage}`,
      };

      toggleWarning(warning);
    }
  };
};
